<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    no-close-on-backdrop
    :ok-disabled="form.errors.any() || bloqueioVinculosExpedicaoEdit"
    v-model="showModal"
    @ok="handleOk"
    @shown="onModalShown"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-col class="p-0">
        <label>Transportadora</label>
        <multiselect
          v-model="transportadoraSelected"
          :options-limit="300"
          :limit="2"
          :limit-text="limitText"
          :options="optionsTransportadora"
          track-by="value"
          label="label"
          id="transportadora"
          placeholder="Cliente ( Digite 3 caracteres para pesquisar )"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :searchable="true"
          :loading="isLoadingTransportadora || bloqueioVinculosExpedicaoEdit"
          :disabled="bloqueioVinculosExpedicaoEdit"
          @search-change="listaTransportadora"
        ></multiselect>
        <b-form-feedback
          v-text="form.errors.get('pessoa_id_for')"
          v-if="form.errors.has('pessoa_id_for')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Unidade Parceira</label>
        <multiselect
          v-model="pessoaParceiraSelected"
          :options="this.$parent.optionsPessoaParceira"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :disabled="enableButton"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('pespar_id')"
          v-if="form.errors.has('pespar_id')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Unidade Transporte</label>
        <multiselect
          v-model="meioTranspSelected"
          :options="this.$parent.optionsTpRodado"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="
            bloqueioVinculosExpedicaoEdit ||
            this.form.pessoa_id == '' ||
            this.form.pessoa_id == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id')"
          v-if="form.errors.has('meiotransp_id')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Meio Transporte primário</label>
        <multiselect
          v-model="meioTranspPrimarioSelected"
          :options="optionsMeioTranspPrimario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="
            bloqueioVinculosExpedicaoEdit ||
            this.form.meiotransp_id == '' ||
            this.form.meiotransp_id == undefined
          "
          @input="
            populaMeioTranspSecundario(meioTranspPrimarioSelected);
            populaMeioTranspTerciario(meioTranspPrimarioSelected);
            populaMotoristas(meioTranspPrimarioSelected);
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_pri')"
          v-if="form.errors.has('meiotransp_id_pri')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.form.tp_rodado_pri == 3" class="p-0">
        <label>Meio Transporte secundário</label>
        <multiselect
          v-model="meioTranspSecundarioSelected"
          :options="optionsMeioTranspSecundario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="bloqueioVinculosExpedicaoEdit"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_sec')"
          v-if="form.errors.has('meiotransp_id_sec')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.form.tp_rodado_pri == 3" class="p-0">
        <label>Meio Transporte terciário</label>
        <multiselect
          v-model="meioTranspTerciarioSelected"
          :options="optionsMeioTranspTerciario"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="bloqueioVinculosExpedicaoEdit"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('meiotransp_id_ter')"
          v-if="form.errors.has('meiotransp_id_ter')"
        ></b-form-feedback>
      </b-col>
      <b-col
        v-if="
          optionsMotoristas.length > 0 ||
          this.form.meiotransp_id_pri != '' ||
          this.form.meiotransp_id_pri != undefined
        "
        class="p-0"
      >
        <label>Motorista</label>
        <multiselect
          v-model="motoristaSelected"
          :options="optionsMotoristas"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="
            bloqueioVinculosExpedicaoEdit ||
            this.form.meiotransp_id_pri == '' ||
            this.form.meiotransp_id_pri == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('veimot_id')"
          v-if="form.errors.has('veimot_id')"
        ></b-form-feedback>
      </b-col>
      <b-col
        v-if="
          optionsMotoristas.length > 0 ||
          this.form.meiotransp_id_pri != '' ||
          this.form.meiotransp_id_pri != undefined
        "
        class="p-0"
      >
        <label>Motorista - Secundario</label>
        <multiselect
          v-model="motoristaSecundarioSelected"
          :options="optionsMotoristas"
          track-by="value"
          label="label"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
          :loading="bloqueioVinculosExpedicaoEdit"
          :disabled="
            bloqueioVinculosExpedicaoEdit ||
            this.form.meiotransp_id_pri == '' ||
            (this.form.meiotransp_id_pri == undefined &&
              this.motoristaSelected == '') ||
            this.motoristaSelected == undefined
          "
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('veimot_id_sec')"
          v-if="form.errors.has('veimot_id_sec')"
        ></b-form-feedback>
      </b-col>
      <b-col class="p-0">
        <label>Ajudante</label>
        <multiselect
          v-model="ajudantes"
          :options="optionsAjudantes"
          track-by="value"
          label="label"
          :limit="3"
          :max="3"
          :hide-selected="true"
          :multiple="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('carmeitranaju_id')"
          v-if="form.errors.has('carmeitranaju_id')"
        ></b-form-feedback>
      </b-col>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner
          v-if="loading || bloqueioVinculosExpedicaoEdit"
          :message="
            bloqueioVinculosExpedicaoEdit && modal_acao === 'u'
              ? 'Carregando vínculos da transportadora...'
              : 'Processando...'
          "
        ></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled || bloqueioVinculosExpedicaoEdit"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import accounting from "accounting";
import { expedicaoEndpoints } from "../services/expedicaoEndpoints";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      debounceTransportadora: null,
      localOptionsVeiculo: [],
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      optionsAjudantes: [],
      optionsMeioTranspPrimario: [],
      motoristaSelected: [],
      motoristaSecundarioSelected: [],
      optionsMotoristas: [],
      meioTranspSelected: [],
      transportadoraSelected: [],
      meioTranspPrimarioSelected: [],
      meioTranspSecundarioSelected: [],
      meioTranspTerciarioSelected: [],
      tpCargaSelected: [],
      loading: false,
      isDisabled: false,
      disableMeioTranspPri: true,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      /** Preenchido em `onEdit` com `cargaMeioTransp.cargaMeioTranspAjudante` da listagem `/api/expedicao`; aplicado após `loadCargaMeioTranspAjudante`. */
      pendingCargaMeioTranspAjudanteFromList: null,
      ajudantes: [],
      ajudante: [],
      enableButton: false,
      isLoadingTransportadora: false,
      bloqueioVinculosExpedicaoEdit: false,
      omitirPopulaMeioTranspEdit: false,
      skipProximoFetchVinculos: false,
      optionsTipoCarga: [],
      pessoaParceiraSelected: [],
      optionsTransportadora: [],
      optionsMeioTranspSecundario: [],
      optionsMeioTranspTerciario: [],
      errors_array: [],
      docfis: [{ docfis_id: "" }],
      form: new Form({
        docfis: [],
        pespar_id: "",
        carga_id: "",
        carmeitran_id: "",
        pessoa_id: "",
        meiotransp_id: "",
        meiotransp_id_pri: "",
        tp_rodado_pri: "",
        meiotransp_id_sec: "",
        meiotransp_id_ter: "",
        veimot_id: "",
        veimot_id_sec: "",
        veiculo_id: "",
        ajudante: [
          {
            pessoa_id: "",
            status: "",
            carmeitranaju_id: "",
          },
        ],
      }),
      helpForm: new Form({ search: "" }),
      vinculoForm: new Form({ pessoa_id: "" }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    meioTranspSelected(obj) {
      if (obj == null || Array.isArray(obj)) {
        this.form.meiotransp_id = "";
        return;
      }
      this.form.meiotransp_id = obj.value;
      if (this.omitirPopulaMeioTranspEdit) {
        return;
      }
      this.populaMeioTranspPrimario(obj.tp_rodado, obj.dados);
    },
    transportadoraSelected(obj) {
      if (obj && !Array.isArray(obj) && obj.value) {
        this.form.pessoa_id = obj.value;
        if (this.skipProximoFetchVinculos) {
          this.skipProximoFetchVinculos = false;
          return;
        }
        this.limpaCamposAoTrocarTransportadora();
        this.getVinculosTransportadora(obj.value);
      } else {
        this.form.pessoa_id = "";
        this.limpaCamposAoTrocarTransportadora();
        this.optionsMeioTranspPrimario = [];
        this.optionsMeioTranspSecundario = [];
        this.optionsMeioTranspTerciario = [];
        this.localOptionsVeiculo = [];
      }
    },
    pessoaParceiraSelected(obj) {
      obj != null
        ? (this.form.pespar_id = obj.value)
        : (this.form.pespar_id = "");
    },
    meioTranspPrimarioSelected(obj) {
      if (obj != null) {
        this.form.meiotransp_id_pri = obj.value;
        this.form.tp_rodado_pri = obj.tp_rodado;
        this.form.veiculo_id = obj.veiculo_id;
        if (!this.omitirPopulaMeioTranspEdit) {
          this.populaMotoristas(obj);
        }
      } else {
        this.form.meiotransp_id_pri = "";
        this.form.tp_rodado_pri = "";
        this.form.veiculo_id = "";
        this.motoristaSelected = [];
        this.motoristaSecundarioSelected = [];
      }
    },
    meioTranspSecundarioSelected(obj) {
      obj != null
        ? (this.form.meiotransp_id_sec = obj.value)
        : (this.form.meiotransp_id_sec = "");
    },
    meioTranspTerciarioSelected(obj) {
      obj != null
        ? (this.form.meiotransp_id_ter = obj.value)
        : (this.form.meiotransp_id_ter = "");
    },
    motoristaSelected(obj) {
      obj != null
        ? (this.form.veimot_id = obj.value)
        : (this.form.veimot_id = "");
    },
    motoristaSecundarioSelected(obj) {
      obj != null
        ? (this.form.veimot_id_sec = obj.value)
        : (this.form.veimot_id_sec = "");
    },
  },
  methods: {
    getCargaMeioTranspAjudanteFromResponse(response) {
      if (!response) {
        return [];
      }

      if (Array.isArray(response)) {
        return response;
      }

      if (Array.isArray(response.data)) {
        return response.data;
      }

      const buckets = [
        response.cargaMeioTranspAjudante,
        response.ajudante,
      ];

      for (const bucket of buckets) {
        if (Array.isArray(bucket)) {
          return bucket;
        }
        if (bucket && Array.isArray(bucket.data)) {
          return bucket.data;
        }
      }

      return [];
    },
    flattenCargaMeioTranspAjudanteItem(obj) {
      if (!obj || typeof obj !== "object") {
        return obj;
      }
      const p = obj.pessoa;
      if (!p || typeof p !== "object") {
        return obj;
      }
      const out = { ...obj };
      if (p.pessoaFisica) {
        out.pessoa_id =
          out.pessoa_id != null ? out.pessoa_id : p.pessoaFisica.pessoaId;
        out.nome = out.nome != null ? out.nome : p.pessoaFisica.nome;
      }
      if (p.pessoaJuridica) {
        out.pessoa_id =
          out.pessoa_id != null ? out.pessoa_id : p.pessoaJuridica.pessoaId;
        out.nome = out.nome != null ? out.nome : p.pessoaJuridica.razaoSocial;
      }
      if (p.pessoaExterior) {
        out.pessoa_id =
          out.pessoa_id != null ? out.pessoa_id : p.pessoaExterior.pessoaId;
        out.nome = out.nome != null ? out.nome : p.pessoaExterior.nome;
      }
      return out;
    },
    getPessoaIdFromCargaMeioTranspAjudanteRow(row) {
      if (!row) {
        return null;
      }
      if (row.pessoa_id != null || row.pessoaId != null) {
        return row.pessoa_id != null ? row.pessoa_id : row.pessoaId;
      }
      const flat = this.flattenCargaMeioTranspAjudanteItem(row);
      return flat.pessoa_id != null ? flat.pessoa_id : null;
    },
    getNomeFromCargaMeioTranspAjudanteRow(row) {
      const flat = this.flattenCargaMeioTranspAjudanteItem(row);
      return flat.nome || "";
    },
    syncAjudantesSelectionFromPendingList() {
      const rows = this.pendingCargaMeioTranspAjudanteFromList;
      this.pendingCargaMeioTranspAjudanteFromList = null;
      if (!rows || !rows.length) {
        return;
      }

      const selected = [];
      for (const row of rows) {
        const pessoaId = this.getPessoaIdFromCargaMeioTranspAjudanteRow(row);
        if (pessoaId == null) {
          continue;
        }

        const pid = Number(pessoaId);
        const base = this.optionsAjudantes.find(
          (o) =>
            Number(o.value) === pid ||
            Number(o.pessoa_id) === pid
        );

        let statusVal = 1;
        if (
          row.status &&
          row.status.valor != null &&
          row.status.valor !== ""
        ) {
          statusVal = row.status.valor;
        } else if (base) {
          statusVal = base.status;
        }
        let carmeitranaju;
        if (row.carmeitranajuId != null) {
          carmeitranaju = row.carmeitranajuId;
        } else if (row.carmeitranaju_id != null) {
          carmeitranaju = row.carmeitranaju_id;
        } else {
          carmeitranaju = base ? base.carmeitranaju_id : "";
        }

        if (base) {
          selected.push({
            ...base,
            carmeitranaju_id: carmeitranaju,
            status: statusVal,
          });
        } else {
          const label =
            this.getNomeFromCargaMeioTranspAjudanteRow(row) || String(pessoaId);
          const synthetic = {
            label,
            value: pessoaId,
            pessoa_id: pessoaId,
            status: statusVal,
            carmeitranaju_id: carmeitranaju,
          };
          this.optionsAjudantes = this.optionsAjudantes.concat([synthetic]);
          selected.push(synthetic);
        }
      }
      this.ajudantes = selected;
    },
    loadCargaMeioTranspAjudante() {
      return this.helpForm
        .get(expedicaoEndpoints.cargaMeioTranspAjudante)
        .then((response) => {
          const ajudantes = this.getCargaMeioTranspAjudanteFromResponse(response);

          function pickFirstDefined(o, keys, fallback) {
            if (o == null) {
              return fallback;
            }
            for (let i = 0; i < keys.length; i++) {
              const v = o[keys[i]];
              if (v !== null && v !== undefined) {
                return v;
              }
            }
            return fallback;
          }

          this.optionsAjudantes = ajudantes
            .map((raw) => {
              const obj = this.flattenCargaMeioTranspAjudanteItem(raw);
              const value = pickFirstDefined(obj, [
                "pessoa_id",
                "pessoaId",
                "value",
                "id",
                "carmeitranaju_id",
                "carmeitranajuId",
              ], "");

              const label = pickFirstDefined(
                obj,
                ["nome", "descr", "label"],
                value ? String(value) : ""
              );

              if (!value || !label) {
                return null;
              }

              let statusVal = pickFirstDefined(obj, ["status"], 1);
              if (
                statusVal &&
                typeof statusVal === "object" &&
                statusVal.valor != null
              ) {
                statusVal = statusVal.valor;
              }

              return {
                label,
                value,
                pessoa_id: pickFirstDefined(obj, ["pessoa_id", "pessoaId"], value),
                status: statusVal,
                carmeitranaju_id: pickFirstDefined(obj, [
                  "carmeitranaju_id",
                  "carmeitranajuId",
                ], ""),
              };
            })
            .filter(Boolean);
        })
        .catch((error_) => {
          this.optionsAjudantes = [];
          new ReturnApi(error_, this);
        })
        .then(() => {
          this.syncAjudantesSelectionFromPendingList();
        });
    },
    onModalShown() {
      this.$nextTick(() => {
        this.loadCargaMeioTranspAjudante();
      });
    },
    limpaCamposAoTrocarTransportadora() {
      this.meioTranspSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.optionsMeioTranspPrimario = [];
      this.optionsMeioTranspSecundario = [];
      this.optionsMeioTranspTerciario = [];
      this.optionsMotoristas = [];
      this.form.meiotransp_id = "";
      this.form.meiotransp_id_pri = "";
      this.form.tp_rodado_pri = "";
      this.form.veiculo_id = "";
      this.form.meiotransp_id_sec = "";
      this.form.meiotransp_id_ter = "";
      this.form.veimot_id = "";
      this.form.veimot_id_sec = "";
      this.errors_array = [];
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.carga_id);
      }
    },
    onCreate(data) {
      this.bloqueioVinculosExpedicaoEdit = false;
      this.omitirPopulaMeioTranspEdit = false;
      this.skipProximoFetchVinculos = false;
      this.docfis = [];
      this.errors_array = "";
      this.errors_array = [];
      this.transportadoraSelected = [];
      this.pessoaParceiraSelected = [];
      this.meioTranspSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Carga";
      this.modal_botao = "Editar Carga";
      this.modal_acao = "i";
      this.pendingCargaMeioTranspAjudanteFromList = null;
      this.form.reset();
      this.$refs.modal_form.show();
    },
    async onEdit(data) {
      this.bloqueioVinculosExpedicaoEdit = false;
      this.omitirPopulaMeioTranspEdit = false;
      this.skipProximoFetchVinculos = false;
      this.docfis = [];
      this.errors_array = "";
      this.errors_array = [];
      this.ajudantes = [];
      this.ajudante = [];
      this.form.ajudante = [];
      const ajudantesList =
        data.cargaMeioTransp && data.cargaMeioTransp.cargaMeioTranspAjudante;
      this.pendingCargaMeioTranspAjudanteFromList = Array.isArray(ajudantesList)
        ? ajudantesList.slice()
        : null;
      this.localOptionsVeiculo = [];
      this.meioTranspSelected = [];
      this.transportadoraSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.optionsMeioTranspPrimario = [];
      this.optionsMeioTranspSecundario = [];
      this.optionsMeioTranspTerciario = [];
      this.pessoaParceiraSelected = [];
      this.pessoaParceiraSelected = [];
      this.optionsMotoristas = [];
      this.pessoaParceiraSelected = [];
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Editar Carga";
      this.modal_botao = "Editar Carga";
      this.modal_acao = "u";
      this.form.reset();
      this.disableMeioTranspPri = true;
      this.enableButton = !data.pesparRed && !data.hasOcorrenChegada;
      this.form.carga_id = data.cargaId;
      this.form.carmeitran_id = data.cargaMeioTransp
        ? data.cargaMeioTransp.carmeitranId
        : "";

      let transportadoraOption = null;
      if (data.pessoa != null) {
        if (data.pessoa.pessoaJuridica != null) {
          transportadoraOption = {
            label:
              "PJ -" +
              data.pessoa.cd +
              " - " +
              data.pessoa.pessoaJuridica.razaoSocial +
              " - " +
              this.onFormataCnpj(
                data.pessoa.pessoaJuridica.cnpjBase,
                data.pessoa.pessoaJuridica.cnpjFilial,
                data.pessoa.pessoaJuridica.cnpjDigito
              ) +
              " - " +
              data.pessoa.pessoaJuridica.inscricaoEstadual,
            value: data.pessoa.pessoaJuridica.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
        if (data.pessoa.pessoaFisica != null) {
          transportadoraOption = {
            label:
              "PF -" +
              data.pessoa.pessoaFisica.nome +
              " - " +
              data.pessoa.pessoaFisica.cpf,
            value: data.pessoa.pessoaFisica.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
        if (data.pessoa.pessoaExterior != null) {
          transportadoraOption = {
            label:
              "PE -" +
              data.pessoa.pessoaExterior.nome +
              " - " +
              data.pessoa.pessoaExterior.cd,
            value: data.pessoa.pessoaExterior.pessoaId,
            valida_opentech: data.pessoa.validaOpentech,
          };
        }
      }

      if (data.pessoaParceira != null) {
        this.pessoaParceiraSelected = {
          label: data.pessoaParceira.descr,
          value: data.pessoaParceira.pesparId,
        };
      }

      this.$refs.modal_form.show();

      this.bloqueioVinculosExpedicaoEdit = true;
      this.omitirPopulaMeioTranspEdit = true;

      if (transportadoraOption) {
        this.skipProximoFetchVinculos = true;
        this.transportadoraSelected = transportadoraOption;
      }

      if (
        data.cargaMeioTransp != null &&
        data.cargaMeioTransp.paramTipoRodado != null
      ) {
        this.meioTranspSelected = {
          label:
            data.cargaMeioTransp.paramTipoRodado.descr +
            " - " +
            this.formatNumber(
              data.cargaMeioTransp.paramTipoRodado.capacidadePeso
            ),
          value: data.cargaMeioTransp.paramTipoRodado.partiprodId,
          tp_rodado: data.cargaMeioTransp.paramTipoRodado.tpRodado,
          dados: data,
        };
      }

      this.preencheVeiculoMotoristaDaListagem(data);

      const pessoaId = transportadoraOption ? transportadoraOption.value : null;
      try {
        if (pessoaId) {
          await this.getVinculosTransportadora(pessoaId, { silent: true });
        }
        this.omitirPopulaMeioTranspEdit = false;
        const mt = this.meioTranspSelected;
        if (mt && !Array.isArray(mt) && mt.tp_rodado !== undefined) {
          this.populaMeioTranspPrimario(mt.tp_rodado, mt.dados);
        }
      } catch (e) {
        this.omitirPopulaMeioTranspEdit = false;
      } finally {
        this.bloqueioVinculosExpedicaoEdit = false;
      }
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.docfis = this.docfis;
      this.form
        .put("/api/montagemcarga/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
          this.docfis = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.ajudante = this.ajudantes;
      this.form
        .patch("/api/expedicao/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        if (this.debounceTransportadora) {
          clearTimeout(this.debounceTransportadora);
        }
        this.debounceTransportadora = setTimeout(() => {
          this.helpForm.search = search;
          this.helpForm.status = 1;
          this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
              this.optionsTransportadora = [];
              new ReturnApi(response, this, true, false, false);
              if (response.items.length > 0) {
                response.items.forEach((obj) => {
                  this.optionsTransportadora.push({
                    nome: obj.razao_social,
                    cpf: null,
                    cnpj: this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ),
                    ie: obj.inscricao_estadual,
                    endereco: obj.pessoa.pessoa_endereco[0].endereco,
                    municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                    uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                    label:
                      "PJ -" +
                      obj.pessoa.cd +
                      " - " +
                      obj.razao_social +
                      " - " +
                      this.onFormataCnpj(
                        obj.cnpj_base,
                        obj.cnpj_filial,
                        obj.cnpj_digito
                      ) +
                      " - " +
                      obj.inscricao_estadual,
                    pessoa_id: obj.pessoa_id,
                    valida_opentech: obj.pessoa.valida_opentech,
                    value: obj.pessoa_id,
                  });
                });
              }
              if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                  this.optionsTransportadora.push({
                    nome: obj.nome,
                    cpf: null,
                    cnpj: obj.cuit,
                    ie: null,
                    endereco: obj.pessoa.pessoa_endereco[0].endereco,
                    municipio: obj.pessoa.pessoa_endereco[0].municipio.nome,
                    uf: obj.pessoa.pessoa_endereco[0].municipio.uf.cd,
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    valida_opentech: obj.pessoa.valida_opentech,
                    value: obj.pessoa_id,
                  });
                });
              }
              this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
              this.isLoadingTransportadora = false;
              new ReturnApi(errors, this);
            });
        }, 1000);
      }
    },
    _opcaoMultiselectUnica(list, item) {
      if (
        item == null ||
        Array.isArray(item) ||
        item.value === undefined ||
        item.value === null ||
        item.value === ""
      ) {
        return;
      }
      if (!list.some((o) => o.value === item.value)) {
        list.push(item);
      }
    },
    preencheVeiculoMotoristaDaListagem(dados) {
      if (dados == null || dados.cargaMeioTransp == null) {
        return;
      }
      const cm = dados.cargaMeioTransp;
      if (cm.meioTransportePrimario !== null) {
        const p = cm.meioTransportePrimario;
        const prim = {
          label: p.veiculo.placa,
          value: p.meiotranspId,
          tp_rodado: p.veiculo.paramTipoRodado.tpRodado,
          veiculo_id: p.veiculoId,
        };
        this.meioTranspPrimarioSelected = prim;
        this._opcaoMultiselectUnica(this.optionsMeioTranspPrimario, prim);
        if (
          p.veiculo.veiculoMotorista &&
          p.veiculo.veiculoMotorista.length > 0
        ) {
          const vm0 = p.veiculo.veiculoMotorista[0];
          const mot = {
            label:
              vm0.pessoaMotorista.pessoaFisica.nome +
              " - " +
              vm0.pessoaMotorista.pessoaFisica.cpf,
            value: vm0.veimotId,
          };
          this.motoristaSelected = mot;
          this._opcaoMultiselectUnica(this.optionsMotoristas, mot);
        }
      }
      if (cm.veiculoMotoristaSecundario != null) {
        const s = cm.veiculoMotoristaSecundario;
        const motS = {
          label:
            s.pessoaMotorista.pessoaFisica.nome +
            " - " +
            s.pessoaMotorista.pessoaFisica.cpf,
          value: s.veimotId,
        };
        this.motoristaSecundarioSelected = motS;
        this._opcaoMultiselectUnica(this.optionsMotoristas, motS);
      }
      if (cm.meioTransporteSecundario !== null) {
        const s = cm.meioTransporteSecundario;
        const sec = {
          label: s.veiculo.placa,
          value: s.meiotranspId,
          tp_rodado: s.veiculo.paramTipoRodado.tpRodado,
          veiculo_id: s.veiculoId,
        };
        this.meioTranspSecundarioSelected = sec;
        this._opcaoMultiselectUnica(this.optionsMeioTranspSecundario, sec);
      }
      if (cm.meioTransporteTerciario !== null) {
        const ter = cm.meioTransporteTerciario;
        const t = {
          label: ter.veiculo.placa,
          value: ter.meiotranspId,
          tp_rodado: ter.veiculo.paramTipoRodado.tpRodado,
          veiculo_id: ter.veiculoId,
        };
        this.meioTranspTerciarioSelected = t;
        this._opcaoMultiselectUnica(this.optionsMeioTranspTerciario, t);
      }
    },
    getVinculosTransportadora(pessoa_id, opts) {
      const silent = opts && opts.silent;
      if (!silent) {
        this.loading = true;
      }
      this.vinculoForm.pessoa_id = pessoa_id;
      return this.vinculoForm
        .post("/api/expedicao/vinculostransportadora")
        .then((response) => {
          this.localOptionsVeiculo = response.veiculo || [];
          if (!silent) {
            this.loading = false;
          }
          return response;
        })
        .catch((errors) => {
          if (!silent) {
            this.loading = false;
          }
          new ReturnApi(errors, this);
          return Promise.reject(errors);
        });
    },
    populaMeioTranspPrimario(data, dados) {
      this.meioTranspPrimarioSelected = [];
      this.meioTranspSecundarioSelected = [];
      this.meioTranspTerciarioSelected = [];
      this.motoristaSelected = [];
      this.motoristaSecundarioSelected = [];
      this.errors_array = [];
      this.optionsMeioTranspPrimario = [];
      this.optionsMeioTranspSecundario = [];
      this.optionsMeioTranspTerciario = [];
      this.optionsMotoristas = [];
      let veiculosDescartados = 0;
      let transportadoraId = null;
      if (this.transportadoraSelected) {
          transportadoraId = this.transportadoraSelected.value;
      }
      const now = new Date();
      //Primario
      this.localOptionsVeiculo.forEach((item, i) => {
        if (item.pessoa_id_agenciador != transportadoraId) {
          veiculosDescartados++;
        }
        if (item.tp_rodado == data && item.pessoa_id_agenciador == transportadoraId) {
          if (this.transportadoraSelected.valida_opentech == 1) {
            if (item.ultima_situacao) {
              var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
              if (
                (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                dateExpiracao >= now
              ) {
                this.optionsMeioTranspPrimario.push({
                  label: item.label,
                  value: item.meiotransp_id,
                  tp_rodado: item.tp_rodado,
                  veiculo_id: item.veiculo_id,
                  ultima_situacao: item.ultima_situacao,
                });
              }
            }
          } else {
            this.optionsMeioTranspPrimario.push({
              label: item.label,
              value: item.meiotransp_id,
              tp_rodado: item.tp_rodado,
              veiculo_id: item.veiculo_id,
              ultima_situacao: item.ultima_situacao,
            });
          }
        }
      });
      if (
        Object.keys(this.meioTranspSelected).length > 0 && // se tem algum tp_rodado selecionado
        this.optionsMeioTranspPrimario.length == 0 && // se não achou opções
        veiculosDescartados > 0 // e descartou veículos por causa da transportadora
      ) {
        this.$Simplert.open({
          title: "Erro",
          message: "Nenhum veículo encontrado para essa transportadora selecionada.",
          customCloseBtnText: "Fechar",
          type: "error",
        });
      }
      if (dados != null) {
        if (dados.cargaMeioTransp.meioTransportePrimario !== null) {
          this.meioTranspPrimarioSelected = {
            label: dados.cargaMeioTransp.meioTransportePrimario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransportePrimario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id: dados.cargaMeioTransp.meioTransportePrimario.veiculoId,
          };
          this.motoristaSelected = {
            label:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].pessoaMotorista.pessoaFisica.nome +
              " - " +
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].pessoaMotorista.pessoaFisica.cpf,
            value:
              dados.cargaMeioTransp.meioTransportePrimario.veiculo
                .veiculoMotorista[0].veimotId,
          };
        }
        if (dados.cargaMeioTransp.veiculoMotoristaSecundario != null) {
          this.motoristaSecundarioSelected = {
            label:
              dados.cargaMeioTransp.veiculoMotoristaSecundario.pessoaMotorista
                .pessoaFisica.nome +
              " - " +
              dados.cargaMeioTransp.veiculoMotoristaSecundario.pessoaMotorista
                .pessoaFisica.cpf,
            value: dados.cargaMeioTransp.veiculoMotoristaSecundario.veimotId,
          };
        }
        if (dados.cargaMeioTransp.meioTransporteSecundario !== null) {
          this.meioTranspSecundarioSelected = {
            label: dados.cargaMeioTransp.meioTransporteSecundario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransporteSecundario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransporteSecundario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id:
              dados.cargaMeioTransp.meioTransporteSecundario.veiculoId,
          };
        }
        if (dados.cargaMeioTransp.meioTransporteTerciario !== null) {
          this.meioTranspTerciarioSelected = {
            label: dados.cargaMeioTransp.meioTransporteTerciario.veiculo.placa,
            value: dados.cargaMeioTransp.meioTransporteTerciario.meiotranspId,
            tp_rodado:
              dados.cargaMeioTransp.meioTransporteTerciario.veiculo
                .paramTipoRodado.tpRodado,
            veiculo_id: dados.cargaMeioTransp.meioTransporteTerciario.veiculoId,
          };
        }
      }
      this._opcaoMultiselectUnica(
        this.optionsMeioTranspPrimario,
        this.meioTranspPrimarioSelected
      );
      this._opcaoMultiselectUnica(
        this.optionsMeioTranspSecundario,
        this.meioTranspSecundarioSelected
      );
      this._opcaoMultiselectUnica(
        this.optionsMeioTranspTerciario,
        this.meioTranspTerciarioSelected
      );
      this._opcaoMultiselectUnica(this.optionsMotoristas, this.motoristaSelected);
      this._opcaoMultiselectUnica(
        this.optionsMotoristas,
        this.motoristaSecundarioSelected
      );
    },
    populaMeioTranspSecundario(data) {
      this.meioTranspSecundarioSelected = [];
      this.optionsMeioTranspSecundario = [];
      let transportadoraId = null;
      if (this.transportadoraSelected) {
        transportadoraId = this.transportadoraSelected.value;
      }
      if (data.tp_rodado == 3) {
        const now = new Date();
        //cavalo mecanico
        //Secundario
        this.localOptionsVeiculo.forEach((item, i) => {
          if (item.tp_rodado != 3 && item.pessoa_id_agenciador == transportadoraId) {
            if (this.transportadoraSelected.valida_opentech == 1) {
              if (item.ultima_situacao) {
                var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
                if (
                  (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                  dateExpiracao >= now
                ) {
                  this.optionsMeioTranspSecundario.push({
                    label: item.label,
                    value: item.meiotransp_id,
                    tp_rodado: item.tipo_rodado,
                    veiculo_id: item.veiculo_id,
                    ultima_situacao: item.ultima_situacao,
                  });
                }
              }
            } else {
              this.optionsMeioTranspSecundario.push({
                label: item.label,
                value: item.meiotransp_id,
                tp_rodado: item.tipo_rodado,
                veiculo_id: item.veiculo_id,
                ultima_situacao: item.ultima_situacao,
              });
            }
            //nao seja cavalo mecanico
          }
        });
      }
    },
    populaMeioTranspTerciario(data) {
      this.meioTranspTerciarioSelected = [];
      this.optionsMeioTranspTerciario = [];
      let transportadoraId = null;
      if (this.transportadoraSelected) {
        transportadoraId = this.transportadoraSelected.value;
      }
      if (data.tp_rodado == 3) {
        const now = new Date();
        //cavalo mecanico
        //Terciario
        this.localOptionsVeiculo.forEach((item, i) => {
          if (item.tp_rodado != 3 && item.pessoa_id_agenciador == transportadoraId) {
            if (this.transportadoraSelected.valida_opentech == 1) {
              if (item.ultima_situacao) {
                var dateExpiracao = new Date(item.ultima_situacao.dt_expiracao);
                if (
                  (item.ultima_situacao.tp_situacao == 2 ||
                  item.ultima_situacao.tp_situacao == 11 ||
                  item.ultima_situacao.tp_situacao == 12 ||
                  item.ultima_situacao.tp_situacao == 7) &&
                  dateExpiracao >= now
                ) {
                  this.optionsMeioTranspTerciario.push({
                    label: item.label,
                    value: item.meiotransp_id,
                    tp_rodado: item.tipo_rodado,
                    veiculo_id: item.veiculo_id,
                    ultima_situacao: item.ultima_situacao,
                  });
                }
              }
            } else {
              this.optionsMeioTranspTerciario.push({
                label: item.label,
                value: item.meiotransp_id,
                tp_rodado: item.tipo_rodado,
                veiculo_id: item.veiculo_id,
                ultima_situacao: item.ultima_situacao,
              });
            }
            //nao seja cavalo mecanico
          }
        });
      }
    },
    populaMotoristas(data) {
      this.errors_array = [];
      this.motoristaSelected = [];
      this.optionsMotoristas = [];
      const now = new Date();
      this.localOptionsVeiculo.forEach((item, i) => {
        if (item.veiculo_id == data.veiculo_id) {
          if (item.veiculo_motorista.length > 0) {
            item.veiculo_motorista.forEach((item2, i2) => {
              if (item2.veiculo_id == data.veiculo_id) {
                if(this.isActive(item2)){
                  if (this.transportadoraSelected.valida_opentech == 1) {
                    if (
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco !=
                      null
                    ) {
                      var dateExpiracao = new Date(
                        item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco.dt_expiracao
                      );
                      if (
                        item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco
                          .tp_situacao == 2 &&
                        dateExpiracao >= now
                      ) {
                        this.optionsMotoristas.push({
                          label:
                            item2.pessoa_motorista.pessoa_fisica.nome +
                            " - " +
                            item2.pessoa_motorista.pessoa_fisica.cpf,
                          value: item2.veimot_id,
                        });
                      } else {
                        this.errors_array.push({
                          erro: "Nenhum motorista com status RECOMENDADO para esse veiculo",
                        });
                      }
                    }
                  } else {
                    this.optionsMotoristas.push({
                      label:
                        item2.pessoa_motorista.pessoa_fisica.nome +
                        " - " +
                        item2.pessoa_motorista.pessoa_fisica.cpf,
                      value: item2.veimot_id,
                    });
                  }
                } else {
                  this.errors_array.push({
                          erro: "Nenhum motorista com status RECOMENDADO para esse veiculo",
                        });
                }
              }
                
              if (this.isActive(item2) && item2.is_padrao == 1) {
                if (this.transportadoraSelected.valida_opentech == 1) {
                  if (
                    item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco !=
                    null
                  ) {
                    var dateExpiracao = new Date(
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco.dt_expiracao
                    );
                    if (
                      item2.pessoa_motorista.ultima_pessoa_motorista_ger_risco
                        .tp_situacao == 2 &&
                      dateExpiracao >= now
                    ) {
                      this.motoristaSelected = {
                        label:
                          item2.pessoa_motorista.pessoa_fisica.nome +
                          " - " +
                          item2.pessoa_motorista.pessoa_fisica.cpf +
                          " - Motorista pré-cadastrado como padrão",
                        value: item2.veimot_id,
                      };
                    }
                  }
                } else {
                  this.motoristaSelected = {
                    label:
                      item2.pessoa_motorista.pessoa_fisica.nome +
                      " - " +
                      item2.pessoa_motorista.pessoa_fisica.cpf +
                      " - Motorista pré-cadastrado como padrão",
                    value: item2.veimot_id,
                  };
                }
              }
            });
          } else {
          }
        }
        if (
          this.optionsMotoristas.length <= 0 &&
          this.errors_array.length == 0 &&
          this.optionsMeioTranspPrimario.length > 0 &&
          this.meioTranspPrimarioSelected != null
        ) {
          if (this.transportadoraSelected.valida_opentech == 1) {
            this.errors_array.push({
              erro: "Nenhum motorista com status RECOMENDADO para esse veiculo.",
            });
          } else {
            this.errors_array.push({
              erro: "Nenhum motorista vinculado para esse veiculo.",
            });
          }
        } else {
          this.errors_array = [];
        }
      });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    isActive(obj) {
      if (obj.status !== undefined && obj.status.value !== undefined && obj.status.value !== 1) {
        return false;
      }

      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            if (!this.isActive(obj[key])) {
              return false;
            }
          }
        }
      }

      return true;
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
